import React from 'react';
import './PageLayout.css'
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { ChapterNav } from '../ChapterNav/ChapterNav';
import SideBar from '../SideBar/SideBar';

interface PageLayoutProps {
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  return (
    <div className="page-layout">
      <div className="page-content">
      <Breadcrumbs />

      <main className="content">
        {children}
      </main>
      <ChapterNav />
      </div>
      <div className="sidebar">
        <SideBar />
      </div>
    </div>
  );
};

export default PageLayout;
